import Phaser from 'phaser';
import BattleScene from '.';
import { wait } from 'tower/util';
import Room from './room';

export default class RoomText extends Phaser.GameObjects.BitmapText {
  constructor(
    scene: BattleScene,
    room: Room,
    x: number,
    y: number,
    private animateText: string,
  ) {
    super(scene, x, y, 'textWhite', '');

    scene.add.existing(this);
    room.misc.add(this);
  }

  async play() {
    const blip = this.scene.sound.add('blip');
    this.setText('');

    for (const letter of this.animateText.split('')) {
      this.text += letter;
      blip.play();

      await wait(this.scene, 90);

      if (this.isDestroyed) {
        blip.destroy();
        return;
      }
    }

    blip.destroy();
  }
}
